import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useMemo } from 'react';
import cn from 'classnames';
import styles from './NotificationMobile.module.scss';
import Paragraph from '../../../components/Typography/Paragraph/Paragraph';
import Line from '../../../components/Line/Line';
import NotificationButtons from '../NotificationButtons/NotificationButtons';
import { useTranslation } from 'react-i18next';
const NotificationMobile = ({ isModal, notification }) => {
    const { t } = useTranslation();
    const { type, additionalInfo, createdAt: date } = notification;
    const message = useMemo(() => {
        if (type === 'new_invitation') {
            return `${additionalInfo.from} ${t('wants_connect')}`;
        }
        else if (type === 'guild_request') {
            return `${additionalInfo.from} ${t('wants_connect')}`;
        }
        return '';
    }, [type, additionalInfo]);
    return (_jsxs("div", Object.assign({ className: cn(styles.element, 'd-flex align-items-center justify-content-between') }, { children: [_jsxs("div", Object.assign({ className: 'd-flex flex-column' }, { children: [_jsxs("div", Object.assign({ className: cn('d-flex align-items-center') }, { children: [_jsx("div", { className: styles.dot }), _jsx(Paragraph, { className: styles.desc, fontFamily: 'urbanist', title: message })] })), _jsx(Paragraph, { className: styles.date, size: 4, fontFamily: 'urbanist', title: date.toLocaleUpperCase() }), isModal && _jsx(Line, { className: styles.line })] })), _jsx(NotificationButtons, { className: cn(styles.button), notification: notification })] })));
};
export default NotificationMobile;
